import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BcConfigService } from 'common/config/provider';
import { initializeModule } from './actions/integrations.actions';
import { GenesysCloudIntegrationsEffects } from './effects/integrations.effects';
import { genesysCloudIntegrationsReducer } from './reducers/integrations.reducers';
import { featureKey } from './reducers/feature-key';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudIntegrationsReducer),
    EffectsModule.forFeature([GenesysCloudIntegrationsEffects])
  ]
})
export class GenesysCloudIntegrationsModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    store.dispatch(initializeModule());
  }
}
